import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

interface mutateProps {
  communityId: string;
  ownershipId: string;
  data: any;
}

const mutateUpdateOwnershipAccount = async ({ communityId, ownershipId, data }: mutateProps) =>
  await axiosAuth.patch(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${ownershipId}/account`, data);

/** Ownership detail edit: legal action, lien, e-communication signup, correspondence. */
const useUpdateOwnershipAccountMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateOwnershipAccount,
    ...queryParams,
  });

export default useUpdateOwnershipAccountMutation;
